var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.706 6.03733C21.3127 5.18026 20.0948 5.18027 19.7014 6.03734L9.38306 28.5199C9.04778 29.2504 9.58155 30.0827 10.3853 30.0827H31.0221C31.8259 30.0827 32.3597 29.2504 32.0244 28.5199L21.706 6.03733ZM20.656 27.0724C22.9631 27.0724 24.8334 25.2021 24.8334 22.895C24.8334 20.5878 22.9631 18.7175 20.656 18.7175C18.3488 18.7175 16.4785 20.5878 16.4785 22.895C16.4785 25.2021 18.3488 27.0724 20.656 27.0724Z",
    fill: "#73CDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2199_15976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9242 16.8552L13.7568 16.2823C12.4953 16.7568 7.15985 18.4313 5.49399 20.9031C2.79363 24.9097 7.05271 25.105 11.7309 24.9686C16.4092 24.8322 27.3329 20.2006 29.9112 18.5554C32.3043 17.0283 36.6353 13.5279 28.7229 14.1218C29.0144 14.1683 34.1573 14.0772 31.9712 16.1263C28.6168 19.2703 13.9579 23.4359 9.35389 22.5808C5.67067 21.8968 11.1425 18.0769 12.9242 16.8552Z",
    fill: "#F9C53A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2199_15976",
    x: 2.43953,
    y: 11.8419,
    width: 37.4645,
    height: 19.7926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.21281,
    dy: 2.21281
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.21281
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2199_15976"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2199_15976",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtid);
export default __webpack_public_path__ + "static/media/atid.eec7e1ee07634937837d4e3569b0f8a0.svg";
export { ForwardRef as ReactComponent };